import { gql } from '@apollo/client';
import { SaleItemWithRelationsListFragment } from '../fragments/SaleItemWithRelationsListFragment';
/**
 * @const SaleItemsWithRelationsListQuery
 * @since 1.0.0
 */
export const SaleItemsWithRelationsListQuery = gql `
  query SaleItemsWithRelationsListQuery($input: SaleItemsInput) {
    saleItems(input: $input) {
      items {
        ...SaleItemWithRelationsListFragment
      }
      count
    }
  }

  ${SaleItemWithRelationsListFragment}
`;
